// import HomePage from "./pages/home-page/HomePageAsync.vue";
import { createRouter, createWebHistory } from "vue-router";
import { appLinks } from "@vendata/power-up-links";

// BEGIN WORKFLOW AREA page-imports FOR vue/add-view
import AsyncPartsPage from "./pages/parts-page/PartsPageAsync.vue";
import CreditAsync from "./pages/credit/CreditAsync.vue";
import MyListingsDetailAsync from "./pages/my-listings/detail/DetailAsync.vue";
import MyListingsEditAsync from "./pages/my-listings/edit/EditAsync.vue";
import MyPortalAsync from "./pages/my-portal/MyPortalAsync.vue";
import OnboardingAsync from "./pages/onboarding/OnboardingAsync.vue";
import PartsPageDetailAsync from "./pages/parts-page/detail/DetailAsync.vue";
import RepairAsync from "./pages/repair/RepairAsync.vue";
import SellPartAsync from "./pages/sell-part/SellPartAsync.vue";
import CreditStatementAsync from "./pages/credit-statement/CreditStatementAsync.vue";
import RepairDetailAsync from "./pages/repair-detail/RepairDetailAsync.vue";
// END WORKFLOW AREA

const routes = [
  // BEGIN WORKFLOW AREA page-routes FOR vue/add-view
  { path: "/", component: AsyncPartsPage, meta: { disableContainer: true } },
  {
    path: appLinks.onboarding.path,
    component: OnboardingAsync,
    meta: { disableContainer: true },
  },
    {
      path: appLinks.sellPart.path,
      component: SellPartAsync,
      meta: { disableContainer: true },
    },
    {
      path: appLinks.myListingsEdit.path,
      component: MyListingsEditAsync,
      meta: { disableContainer: true },
    },
    {
      path: appLinks.myListingsDetail.path,
      component: MyListingsDetailAsync,
      meta: { disableContainer: true },
    },
    {
      path: appLinks.partsPageDetail.path,
      component: PartsPageDetailAsync,
      meta: { disableContainer: true },
    },
    {
      path: appLinks.credit.path,
      component: CreditAsync,
      meta: { disableContainer: true },
    },
    {
      path: appLinks.repair.path,
      component: RepairAsync,
      meta: { disableContainer: true },
    },
    {
      path: appLinks.myPortal.path,
      component: MyPortalAsync,
      meta: { disableContainer: true },
    },
    {
      path: appLinks.creditStatement.path,
      component: CreditStatementAsync,
    },
    {
      path: appLinks.repairDetail.path,
      component: RepairDetailAsync,
    },
  // END WORKFLOW AREA
];

export const router = createRouter({
  history: createWebHistory("/"),
  routes,
});
